import type { CertificateRule } from '~/pages/backoffice/admin/sessions/certificate-rule-form'
import type { PathChapter } from '~/pages/backoffice/admin/sessions/path-chapters'
import type { PathStep } from '~/pages/backoffice/admin/sessions/path-step'
import { CertificateCondition } from '@zeus/index'

/**
 * La première saisie qui empêche d'enregistrer un parcours, en clé i18n, ou
 * `null`. Contrôlée ici pour répondre dans la langue de l'admin ; l'API refait
 * ses propres contrôles, qui font foi.
 */
export function sessionFormError(form: {
  name: string
  steps: PathStep[]
  chapters: PathChapter[]
  certificate: CertificateRule
}): string | null {
  if (!form.name.trim()) return 'sessions.nameRequired'
  if (form.steps.length === 0) return 'sessions.path.required'
  if (form.certificate.condition === CertificateCondition.SCORE && !((form.certificate.minScore ?? 0) > 0)) {
    return 'sessions.certificate.minScoreRequired'
  }
  if (form.chapters.some(chapter => !chapter.title.trim())) return 'sessions.path.chapter.titleRequired'
  return null
}
